// extracted by mini-css-extract-plugin
module.exports = {"centerTitle":"VaccinationCenter_centerTitle__1BPBb","centerAddress":"VaccinationCenter_centerAddress__32_tx","vaccineFees":"VaccinationCenter_vaccineFees__2roXD"};